import { computed } from "vue";
import { useRoute } from "vue-router";
import { useTenant } from "./useTenant";
import { usePermissions } from "./usePermissions";
import { buildNavigation, buildSettingsLinks } from "@app/config/navigation";

export function useNavigation() {
  const route = useRoute();
  const { tenantId, tenantName } = useTenant();
  const { can, canManageUsers, canManageRoles } = usePermissions();

  const items = computed(() => {
    const currentTenant =
      tenantName.value || localStorage.getItem("tenantName");
    return buildNavigation(tenantId.value)
      .map((item) => {
        if (item.children) {
          const children = item.children.filter((child) => {
            if (!can(child.permission)) return false;
            if (child.tenantOnly && currentTenant !== child.tenantOnly) {
              return false;
            }
            return true;
          });
          if (!children.length) return null;
          return { ...item, children };
        }
        if (!can(item.permission)) return null;
        return item;
      })
      .filter(Boolean);
  });

  const settingsLinks = computed(() =>
    buildSettingsLinks(tenantId.value).filter((link) => {
      if (link.id === "users") return canManageUsers.value;
      if (link.id === "roles") return canManageRoles.value;
      return can(link.permission);
    })
  );

  const showSettings = computed(
    () => canManageUsers.value || canManageRoles.value
  );

  function isActive(item) {
    const path = route.path || "";
    if (item.to && path === item.to) return true;
    if (item.match && path.includes(`/${item.match}`)) return true;
    if (item.children) {
      return item.children.some((child) => isChildActive(child));
    }
    return false;
  }

  function isChildActive(child) {
    const path = route.path || "";
    return Boolean(child.to && path === child.to);
  }

  function markActiveMenu(title) {
    localStorage.setItem("activeMenu", title);
  }

  return {
    items,
    settingsLinks,
    showSettings,
    isActive,
    isChildActive,
    markActiveMenu,
  };
}
